import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  title: {
    id: "page.about.team.title",
  },
  titlePartners: {
    id: "page.about.team.titlePartners",
  },

  teamPersonJensAhrensPosition: { id: "team.person.jens-ahrens.position" },
  teamPersonMarzenCzajkowskaPosition: { id: "team.person.marzena-czajkowska.position" },
  teamPersonDanielDeboyPosition: { id: "team.person.daniel-deboy.position" },
  teamPersonMateuszGlowackiPosition: { id: "team.person.mateusz-glowacki.position" },
  teamPersonKarolinaJaruszewskaPosition: { id: "team.person.karolina-jaruszewska.position" },
  teamPersonSzymonKucharskiPosition: { id: "team.person.szymon-kucharski.position" },
  teamPersonMarcinLuczakPosition: { id: "team.person.marcin-luczak.position" },
  teamPersonArturWalaszczykPosition: { id: "team.person.artur-walaszczyk.position" },
  teamPersonAnaMontePosition: { id: "team.person.ana-monte.position" },
  teamPersonKevinBolenPosition: { id: "team.person.kevin-bolen.position" },
  teamPersonBrianSchmidtPosition: { id: "team.person.brian-schmidt.position" },
  teamPersonHyunkookLeePosition: { id: "team.person.hyunkook-lee.position" },
  teamPersonNielsPontoppidanPosition: { id: "team.person.niels-pontoppidan.position" },
  teamPersonJustynaKlamutPosition: { id: "team.person.justyna-klamut.position" },
  teamPersonMarkusAuerPosition: { id: "team.person.markus-auer.position" },
  teamPersonPawelMaleckiPosition: { id: "team.person.pawel-malecki.position" },
  teamPersonJensAhrensBio: { id: "team.person.jens-ahrens.bio" },
  teamPersonMarzenCzajkowskaBio: { id: "team.person.marzena-czajkowska.bio" },
  teamPersonDanielDeboyBio: { id: "team.person.daniel-deboy.bio" },
  teamPersonMateuszGlowackiBio: { id: "team.person.mateusz-glowacki.bio" },
  teamPersonKarolinaJaruszewskaBio: { id: "team.person.karolina-jaruszewska.bio" },
  teamPersonSzymonKucharskiBio: { id: "team.person.szymon-kucharski.bio" },
  teamPersonMarcinLuczakBio: { id: "team.person.marcin-luczak.bio" },
  teamPersonArturWalaszczykBio: { id: "team.person.artur-walaszczyk.bio" },
  teamPersonAnaMonteBio: { id: "team.person.ana-monte.bio" },
  teamPersonKevinBolenBio: { id: "team.person.kevin-bolen.bio" },
  teamPersonBrianSchmidtBio: { id: "team.person.brian-schmidt.bio" },
  teamPersonHyunkookLeeBio: { id: "team.person.hyunkook-lee.bio" },
  teamPersonNielsPontoppidanBio: { id: "team.person.niels-pontoppidan.bio" },
  teamPersonJustynaKlamutBio: { id: "team.person.justyna-klamut.bio" },
  teamPersonMarkusAuerBio: { id: "team.person.markus-auer.bio" },
  teamPersonPawelMaleckiBio: { id: "team.person.pawel-malecki.bio" },
});
